import * as FileSaver from 'file-saver';
import {
  action, observable,
} from 'mobx';
import Connections from '../../connections';
import {
  getAllTransactions,
  exportAllTransactions,
  getTransactionById,
  notifySapByTransactionId,
  notifySapManually,
  updateTransactionStatus,
} from '../../axios/transactions';
import {
  Transaction, TransactionStatus, TransactionFilterOptions, SapTransactionStatus, PaymentType,
} from '../storeInterfaces/transactionInterface';

export class TransactionsStore {
  @observable transactionsList: Transaction[] = [];

  @observable loading = false;

  @observable selectedNotifyingTransaction: number | null = null;

  @observable transactionsCount = 0;

  @observable selectedTransaction: Transaction = {
    fawryTransactions: [],
    sapTransactions: [],
    deglawyPointsTransactions: [],
    paymobTransactions: [],
  };

  @action
  public async getAllTransactions(tfo: TransactionFilterOptions): Promise<void> {
    try {
      tfo.status = tfo.status === TransactionStatus.ALL ? '' : tfo.status;
      tfo.isSapNotified = tfo.isSapNotified === SapTransactionStatus.ALL ? '' : tfo.isSapNotified;
      tfo.paymentType = tfo.paymentType === PaymentType.ALL ? '' : tfo.paymentType;
      const response = await Connections.wadiDeglaAxios.httpGet(getAllTransactions, {
        params: tfo,
      });
      const {
        transactions,
        transactionsCount,
      } = response.data;
      this.transactionsList = transactions;
      this.transactionsCount = transactionsCount;
      return Promise.resolve();
    } catch (error) {
      this.loading = false;
      console.log(error);
      return Promise.reject(error);
    }
  }

  @action
  public async notifySapTransactions(transactionId: number):Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(notifySapByTransactionId(transactionId), {});
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error.response.data);
    }
  }

  @action
  public async getTransactionById(transactionId: number): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getTransactionById(transactionId));
      this.selectedTransaction = response.data;
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async updateTransactionStatus(id:number, transactionStatus: TransactionStatus) {
    try {
      this.loading = true;
      await Connections.wadiDeglaAxios.httpPut(updateTransactionStatus(id), {
        transactionStatus,
      });
      this.loading = false;
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async download(tfo: TransactionFilterOptions): Promise<void> {
    try {
      this.loading = true;
      tfo.status = tfo.status === TransactionStatus.ALL ? '' : tfo.status;
      tfo.isSapNotified = tfo.isSapNotified === SapTransactionStatus.ALL ? '' : tfo.isSapNotified;
      const response = await Connections.wadiDeglaAxios.httpGet(exportAllTransactions, {
        params: tfo,
        responseType: 'blob',
      });
      await FileSaver.saveAs(response, 'Transactions');
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async notifySapTransactionManually(
    transactionId: number, documentCode: string, documentCodeOData: string,
  ): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPost(notifySapManually, {
        transactionId,
        documentCode,
        documentCodeOData,
      });
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error.response.data);
    }
  }
}
